import { referenceTables } from "./reference-tables";
export function selectAllValues(state, modelKey) {
    var _a;
    const referenceTable = referenceTables[modelKey];
    if (!referenceTable)
        throw new Error(`No form for "${modelKey}"`);
    const formState = state[modelKey];
    const values = {};
    for (const [key, node] of Object.entries(referenceTables[modelKey].keyToNode)) {
        const term = node.type === "iterable-term"
            ? (_a = formState.iterables[node.iterableName].instances[node.iterableIndex]) === null || _a === void 0 ? void 0 : _a.terms[node.termName]
            : formState.terms[node.termName];
        values[key] = term ? term.value : "";
    }
    return values;
}
export function selectValue(state, modelKey, termKey, property = "value") {
    var _a;
    const formState = state[modelKey];
    if (!formState)
        throw new Error(`No form for "${modelKey}"`);
    const node = referenceTables[modelKey].keyToNode[termKey];
    if (!node)
        throw new Error(`No key of "${termKey}" in "${modelKey}" form`);
    const term = node.type === "iterable-term"
        ? (_a = formState.iterables[node.iterableName].instances[node.iterableIndex]) === null || _a === void 0 ? void 0 : _a.terms[node.termName]
        : formState.terms[node.termName];
    return term ? term[property] : "";
}
export function selectFormMeta(modelKey) {
    const referenceTable = referenceTables[modelKey];
    if (!referenceTable)
        throw new Error(`No form for "${modelKey}"`);
    return referenceTable.model.meta;
}
export function* iterateTerms(state, modelKey) {
    var _a;
    const referenceTable = referenceTables[modelKey];
    if (!referenceTable)
        throw new Error(`No form for "${modelKey}"`);
    const model = referenceTables[modelKey].model;
    const formState = state[modelKey];
    for (const [key, node] of Object.entries(referenceTables[modelKey].keyToNode)) {
        yield [
            key,
            node.type === "iterable-term"
                ? (_a = formState.iterables[node.iterableName].instances[node.iterableIndex]) === null || _a === void 0 ? void 0 : _a.terms[node.termName]
                : formState.terms[node.termName],
            node.type === "iterable-term"
                ? model.iterables[node.iterableName].terms[node.termName]
                : model.terms[node.termName],
        ];
    }
}
export function eachTerm(state, modelKey, callback) {
    var _a;
    const referenceTable = referenceTables[modelKey];
    if (!referenceTable)
        throw new Error(`No form for "${modelKey}"`);
    const model = referenceTables[modelKey].model;
    const formState = state[modelKey];
    for (const [key, node] of Object.entries(referenceTables[modelKey].keyToNode)) {
        callback(key, node.type === "iterable-term"
            ? (_a = formState.iterables[node.iterableName].instances[node.iterableIndex]) === null || _a === void 0 ? void 0 : _a.terms[node.termName]
            : formState.terms[node.termName], node.type === "iterable-term"
            ? model.iterables[node.iterableName].terms[node.termName]
            : model.terms[node.termName]);
    }
}
//# sourceMappingURL=selectors.js.map